import { memo } from 'react';

import styles from './Section.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface SectionProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  title: string;
}

const Section: FC<SectionProps> = (props) => {
  const { title, children, ...restProps } = props;

  return (
    <div {...restProps}>
      <div className={styles.title}>{title}</div>
      <>{children}</>
    </div>
  );
};

export default memo(Section);
